Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Flickr", {
  enumerable: true,
  get: function get() {
    return _flickr.Flickr;
  }
});
var _flickr = require("./flickr");